import { DOMAnimations } from '../libs/dom'

export default class Menu {
  constructor() {
    this.nav = document.querySelectorAll('.js-header__menu')
    this.submenuDropdown = document.querySelectorAll('.js-mobile__list-toggle')
    this.init()
  }

  init() {
    this.toggleMenu()
    this.toggleSubmenu()
  }

  toggleMenu() {
    this.nav.forEach((nav) => {
      const menu = nav.querySelector('.js-header__content')
      const menuButton = nav.querySelector('.js-header__button')
      const closeButton = nav.querySelector('.js-header__close')

      menuButton.addEventListener('click', (e) => {
        e.preventDefault()
        menu.classList.toggle('is-opened')
        menuButton.classList.toggle('is-opened')
      })

      closeButton?.addEventListener('click', () => {
        menu.classList.remove('is-opened')
        menuButton.classList.remove('is-opened')
      })

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-header__menu')) {
          menu.classList.remove('is-opened')
          menuButton.classList.remove('is-opened')
        }
      })
    })
  }

  toggleSubmenu() {
    this.submenuDropdown.forEach((list) => {
      const button = list.querySelector('.js-mobile__list-toggle > a')
      const content = list.querySelector('.js-mobile__list-toggle > ul')

      button.addEventListener('click', (e) => {
        e.preventDefault()
        DOMAnimations.slideToggle(content)
      })
    })
  }
}
